import { MessageBox } from 'element-ui'
import Message from './message'
import random_code from '../utils/random_code'

// 修改 element 的弹窗的 promise 行为，使其始终不会 reject
// alert resolve(undefined)
// confirm resolve(Boolean) 返回 true/false
// prompt resolve(String|Boolean) 输入了内容（非空白）时 resolve(String)(trim后)；取消或者输入了几个空格resolve(false)
// dangerConfirm 跟 confirm 差不多，会要求用户输入一个数字进行确认

const handleCancel = (options, message = '操作已取消') => {
  if (options && options.cancel_tip !== false) Message(message)
  return false
}

export let msgbox = (options, callback) => {
  return MessageBox(options, callback).catch(() => handleCancel(options))
}

export let alert = (message, title, options) => {
  if (typeof title === 'object') {
    options = title
    title = ''
  }
  return MessageBox.alert(message, title, options).catch(() => {})
}

export let confirm = (message, title, options) => {
  if (typeof title === 'object') {
    options = title
    title = ''
  }
  return MessageBox.confirm(message, title, options).catch(() => handleCancel(options))
}

export let prompt = (message, title, options) => {
  if (typeof title === 'object') {
    options = title
    title = ''
  }
  return MessageBox.prompt(message, title, options).then(result => {
    let value = result && result.value && result.value.trim()
    return value || handleCancel(options)
  }, () => handleCancel(options))
}

export let dangerConfirm = async (message, title, options) => {
  if (typeof title === 'object') {
    options = title
    title = ''
  }
  title = title || '确认'
  options = options || {}
  let code = random_code(options.code_length || 2)
  let value = await prompt(`${message}\n确认请输入确认码: ${code}`, title, options)
  if (!value) return
  if (value !== code) return handleCancel(options, '确认码错误，操作已取消')
  return true
}



// WEBPACK FOOTER //
// ./src/common/messageBox.js